import ViewSongPlugins from './ViewSongPlugins';

export default ViewSongPlugins;
